module.exports = __webpack_public_path__ + "static/media/Week6.c2b5481a.pdf";